<template>
  <footer class="footer">
  <div class="content has-text-centered">
    <p>
    Desenvolvido com muito <b-icon class="heart" icon="heart" custom-size="mdi-18px" /> pela <router-link class="colorFade" to="/contributors">Earth Team.</router-link>
    </p>
  </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.heart {
  transition: color 0.25s ease;
}
.heart:hover {
  color: #00b8ff;
}
.footer {
  padding: 10px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
}
.colorFade {
  -webkit-transition: 0.25s color ease-out;
  -moz-transition: 0.25s color ease-out;
  transition: 0.25s color ease-out;
}
</style>
